import { useOutletContext } from 'react-router-dom';
import GeofenceManager from '../components/executive-protection/GeofenceManager';
import type { ExecutiveProtectionContextType } from '../layouts/ExecutiveProtectionLayout';

export default function Geofences() {
  const {
    googleMapsApiKey,
    geofences,
    activities,
    isLoading,
    handlers
  } = useOutletContext<ExecutiveProtectionContextType>();

  if (isLoading.geofences || isLoading.activities) {
    return <div className="text-center py-8 text-secondary-500">Loading geofences...</div>;
  }

  // Normalize geofence coordinates (API returns Prisma Decimal as string)
  const normalizedGeofences = geofences.map(g => ({
    ...g,
    centerLatitude: typeof g.centerLatitude === 'string' ? parseFloat(g.centerLatitude) : g.centerLatitude,
    centerLongitude: typeof g.centerLongitude === 'string' ? parseFloat(g.centerLongitude) : g.centerLongitude,
    radiusMeters: typeof g.radiusMeters === 'string' ? parseFloat(g.radiusMeters) : g.radiusMeters,
    fenceType: g.fenceType as 'SAFE_ZONE' | 'RESTRICTED_ZONE' | 'ALERT_ZONE',
  }));

  // Only show activities that are planned or in progress
  const activeActivities = activities.filter(
    a => a.status === 'PLANNED' || a.status === 'IN_PROGRESS'
  );

  // Separate activities with valid coordinates from those without
  const activitiesWithLocation = activeActivities
    .map(a => ({
      ...a,
      locationLatitude: typeof a.locationLatitude === 'string'
        ? parseFloat(a.locationLatitude as string)
        : a.locationLatitude,
      locationLongitude: typeof a.locationLongitude === 'string'
        ? parseFloat(a.locationLongitude as string)
        : a.locationLongitude,
    }))
    .filter(a =>
      a.locationLatitude !== null && a.locationLatitude !== undefined &&
      a.locationLongitude !== undefined &&
      !isNaN(a.locationLatitude) &&
      !isNaN(a.locationLongitude)
    ) as Array<{
      id: string;
      title: string;
      activityType: string;
      status: string;
      locationLatitude: number;
      locationLongitude: number;
    }>;

  const missingLocationCount = activeActivities.length - activitiesWithLocation.length;

  return (
    <GeofenceManager
      apiKey={googleMapsApiKey}
      geofences={normalizedGeofences}
      onGeofenceCreate={handlers.handleGeofenceCreate}
      onGeofenceUpdate={handlers.handleGeofenceUpdate}
      onGeofenceDelete={handlers.handleGeofenceDelete}
      activities={activitiesWithLocation}
      missingLocationCount={missingLocationCount}
    />
  );
}
